/**
 * Returns `value` only when it is an absolute http(s) URL, else null.
 * Guards every href/window.open fed by database text: `javascript:` links in
 * project_url/github_url run on the same origin as /admin (session in
 * localStorage). Same rule the dashboard API/MCP enforce on write
 * (`format: "http-url"` in supabase/functions/_shared/dashboard/validate.ts).
 */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}
